import { USlideLoading } from "../common/ui.slide";

export function CMainLoading(props) {
    const { loading, ...rest } = props;
    return <USlideLoading
        open={!loading}
        sx={{
            backgroundColor: '#091112',
        }}
        leftSx={{
            backgroundImage: "url(/static/icon/logo/clogo-left.png)",
            backgroundPosition: 'right',
            backgroundRepeat: 'no-repeat',
        }}
        rightSx={{
            backgroundImage: "url(/static/icon/logo/clogo-right.png)",
            backgroundPosition: 'left',
            backgroundRepeat: 'no-repeat',
        }} {...rest} />
}
